<template>
  <div id="app">
    <keep-alive>
      <router-view
        v-wechat-title="$route.meta.title"
        v-if="$route.meta.keepAlive"
      />
    </keep-alive>
    <router-view
      v-wechat-title="$route.meta.title"
      v-if="!$route.meta.keepAlive"
    />
  </div>
</template>
<script>
export default {};
</script>

<style lang="stylus">
#app
    min-height 100vh
    overflow auto
</style>
